import { render, staticRenderFns } from "./smartBigData.vue?vue&type=template&id=eefe0124&scoped=true"
import script from "./smartBigData.vue?vue&type=script&lang=js"
export * from "./smartBigData.vue?vue&type=script&lang=js"
import style0 from "./smartBigData.vue?vue&type=style&index=0&id=eefe0124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefe0124",
  null
  
)

export default component.exports